import createEnum from 'scripts/lib/create_enum';

const AttachmentStatus = createEnum('AVAILABLE', 'ERROR');

export default AttachmentStatus;
